import { FormControl, InputLabel, Select, MenuItem, Grid } from "@material-ui/core"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { FormatoFechaIso } from "../../../../../utils/FormatFecha"
import { addMetodoPagoAction, addFechaSalidaAction, obtenerFechaSalidaAction, addItemsAction, obtenerHabitacionesAction, obtenerNoMensualidadHibridoCalculoAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { formatDinero } from "../../../../../utils/formatDinero"
import { catTipoItem } from "../../../../../constant/catTipoItem"

const FieldSalida = () => {
    const dispatch = useDispatch()
    const {
        montoFinal,
        listaFechaSalida,
        fechaSalida,
        paquete,
        listaItems,
        cantidadPasajeros,
        clavePaquete
    } = useSelector(store => store.cotizadorPaquete)


    useEffect(() => {
        dispatch(obtenerHabitacionesAction({ ClavePaquete: clavePaquete }))
        dispatch(obtenerFechaSalidaAction({ ClavePaquete: clavePaquete }))
    }, [dispatch, clavePaquete])

    const handleSelecFecha = (event) => {
        const value = event.target.value
        const arrayValue = value.split(",")
        const fecha = arrayValue[2]
        const fechaFormato = `${FormatoFechaIso({ date: fecha, formato: "yyyy/MM/dd" })}`
        const fechaFormato2 = FormatoFechaIso({ date: fecha, formato: "MMddyyyy" })
        dispatch(addFechaSalidaAction({ fechaSalida: value, fecha }))
        dispatch(addMetodoPagoAction({ metodoPago: "0" }))
        dispatch(obtenerNoMensualidadHibridoCalculoAction({ fechaSalida: fechaFormato2 }))
        let arraItems = listaItems.filter(item => item.type !== catTipoItem.SALIDA)
        let itemPaquete = {
            id: arrayValue[0],
            name: fechaFormato,
            price: arrayValue[3],
            currency: paquete.Moneda?.Clave,
            type: catTipoItem.SALIDA,
            quantity: cantidadPasajeros
        }
        arraItems.push(itemPaquete)
        dispatch(addItemsAction({ listaItem: arraItems }))
    }
    return (
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "97%" }}>
                    <InputLabel id="lFecha">Fecha de salida</InputLabel>
                    <Select
                        disabled={clavePaquete === "0"}
                        labelId="lFecha"
                        id="SFecha"
                        name="SFecha"
                        onChange={handleSelecFecha}
                        label="Fecha de salida"
                        value={fechaSalida}
                    >
                        <MenuItem value="0,0,0,0" disabled>
                            {"Seleccione una opción"}
                        </MenuItem>
                        {listaFechaSalida.map((item, index) => (
                            <MenuItem key={index} value={`${item.IdObjeto},${item.IdBloqueSalida},${item.FechaSalida},${item.Precio}`}>
                                {`${FormatoFechaIso({ date: item.FechaSalida, formato: "dd MMMM yyyy" })} (${formatDinero(item.Precio)})`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}
export default FieldSalida